import { Component } from "react";
import type { ErrorInfo } from "react";
import styles from "./styles.module.scss";

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // This could also be logged to an error reporting service
    console.error(error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.container}>
          <h1>Application error</h1>
          <p>
            We apologize for any inconvenience. Visit our{" "}
            <a href="https://www.mckinsey.com/">home page</a> or use the
            navigation menu to find what you need.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}
